import lowercaseFormatDuration from 'owa-duration-formatter/lib/lowercase';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { getStore } from '../store/store';
import { getShortenEventsDurationBy } from 'owa-calendar-cloud-settings-utils';

const SECONDS_IN_MINUTE = 60;
const durations = [15, 30, 60];

export default function createDurationDropdownOptions(): IDropdownOption[] {
    const { durationSearchCriteria: eventDuration, shouldAdjustStartTimeEndTime } = getStore();

    let meetingDurationOptions: IDropdownOption[] = [];

    let isSameAsAdjustedDurationOption: boolean = false;
    if (shouldAdjustStartTimeEndTime) {
        // Adjust the durations to display to support the shorteningEvents settings
        // but keep the keys of the dropdown options the same, since the call to
        // find meeting times should be for the full duration. (We adjust the response suggestions to respect shortenEvents settings)
        // This logic won't be required after FindMeetingTimes supports shorteningEvents.
        durations.forEach(duration => {
            const durationToDisplay = getShortenedDuration(duration);
            if (durationToDisplay == eventDuration) {
                // Prevent adding a "custom" duration (current duration of the event in the time picker) that is just the result of shorteningEvents settings
                isSameAsAdjustedDurationOption = true;
            }
            const durationDropdownOption = createDurationOption(durationToDisplay);
            meetingDurationOptions.push(durationDropdownOption);
        });

        if (!isSameAsAdjustedDurationOption) {
            const currentDurationOption = createDurationOption(eventDuration);
            meetingDurationOptions.unshift(currentDurationOption);
        }
    } else {
        if (!durations.includes(eventDuration)) {
            const currentDurationOption = createDurationOption(eventDuration);
            meetingDurationOptions.push(currentDurationOption);
        }
        durations.forEach(duration => {
            const option = createDurationOption(duration);
            meetingDurationOptions.push(option);
        });
    }
    return meetingDurationOptions;
}

function createDurationOption(duration: number): IDropdownOption {
    return {
        key: duration,
        text: lowercaseFormatDuration(duration * SECONDS_IN_MINUTE),
    };
}

export function getShortenedDuration(duration: number): number {
    // Get the amount of minutes we need to substract from the duration option
    const durationToSubstract = getShortenEventsDurationBy(duration);
    return Math.max(duration - durationToSubstract, 0);
}

export function getShortenedDefaultDurations(): number[] {
    let shortenedDefaultDurations: number[] = [];
    durations.forEach(duration => {
        const shortenedDuration = getShortenedDuration(duration);
        shortenedDefaultDurations.push(shortenedDuration);
    });
    return shortenedDefaultDurations;
}

export function getDefaultDurationForShortenedDuration(shortenedDuration: number): number {
    let defaultDuration = durations.filter(
        duration => getShortenedDuration(duration) == shortenedDuration
    );
    return defaultDuration?.[0] ?? shortenedDuration;
}
